import { EditLink as EditLinkComponent } from '@/templates/EditLink'
import { Layout } from '@/Layout'

export const EditLink = () => {
  return (
    <Layout title="Edit Link" showBackButton showCreateButton={false}>
      <EditLinkComponent />
    </Layout>
  )
}
